import {
  EventBuilder as EventBuilderInterface,
  EventType,
  Event,
} from "@jupiter/types";
import { Md5 as md5 } from "md5-typescript";

export const EventBuilder: EventBuilderInterface = {
  createExceptionEvent(exception: any, otherProperties?: Record<string, any>) {
    const event: Event = {
      event: {
        name: "error",
        type: EventType.ERROR,
        data: {
          brief: md5.init(exception),
          stack: exception,
          ...otherProperties,
        },
      },
    };
    return event;
  },
  createCustomEvent(eventName: string, otherProperties?: Record<string, any>) {
    const event: Event = {
      event: {
        name: eventName,
        type: EventType.CUSTOM_EVENT,
        data: {
          ...otherProperties,
        },
      },
    };
    return event;
  },
  createPageViewEvent(
    from: string | null | undefined,
    to: string | null | undefined,
    otherProperties?: Record<string, any>
  ) {
    const event: Event = {
      event: {
        name: "pv",
        type: EventType.PV,
        data: {
          ...otherProperties,
          from,
          to,
        },
      },
    };
    return event;
  },
};
